import React, { memo, useMemo } from 'react';
import { getContext, Symbols } from 'choerodon-ui/shared';
import { getPrefixCls } from '../configure/utils';
const RadioContext = getContext(Symbols.RadioContext, { getPrefixCls });
const BaseRadioContextProvider = function RadioContextProvider(props) {
    const { children, radioGroup, getPrefixCls: getGlobalPrefixCls } = props;
    const value = useMemo(() => ({
        radioGroup,
        getPrefixCls: getGlobalPrefixCls,
    }), [getGlobalPrefixCls, radioGroup]);
    return (React.createElement(RadioContext.Provider, { value: value }, children));
};
BaseRadioContextProvider.displayName = 'RadioContextProvider';
export const RadioContextProvider = memo(BaseRadioContextProvider);
export default RadioContext;
